import { GetPhaseDetails } from '@/_services/jobs';

export default {
  state: {
    loading: false,
    phases: [],
  },
  getters: {
    loading: state => state.loading,
    phases: state => state.phases,
  },
  mutations: {
    addComposite(state, payload) {
      state.phases = state.phases.map(phase => {
        if (phase.id === payload.phaseId) {
          return {
            ...phase,
            compositesDTO: [...phase.compositesDTO, payload.composite],
          };
        }

        return phase;
      });
    },
    addPhases(state, phases) {
      const newPhases = phases.map(phase =>
        Object.assign(phase, {
          compositesDTO: [],
          totalLaborCost: 0,
          totalMaterialCost: 0,
          totalSubcontractingCost: 0,
        }),
      );

      state.phases = state.phases.concat(newPhases).sort((a, b) => a.code.localeCompare(b.code));
    },
    destroyComposite(state, payload) {
      state.phases = state.phases.map(phase => {
        if (phase.id === payload.phaseId) {
          phase.compositesDTO = phase.compositesDTO.filter(({ id }) => id !== payload.compositeId);
        }

        return phase;
      });
    },
    destroyMaterial(state, payload) {
      state.phases = state.phases.map(phase => {
        if (phase.id === payload.phaseId) {
          phase.compositesDTO = phase.compositesDTO.map(composite => {
            if (composite.id === payload.compositeId) {
              composite.materials = composite.materials.filter(({ id }) => id !== payload.materialId);
            }

            return composite;
          });
        }

        return phase;
      });
    },
    destroyPhase(state, phaseId) {
      state.phases = state.phases.filter(({ id }) => id !== phaseId);
    },
    setLoading(state, loading = true) {
      state.loading = loading;
    },
    setPhases(state, payload) {
      state.phases = payload;
    },
    updateComposite(state, payload) {
      state.phases = state.phases.map(phase => {
        if (phase.id === payload.phaseId) {
          phase.compositesDTO = phase.compositesDTO.map(composite => {
            if (composite.id === payload.compositeId) {
              composite = payload.callback(composite);
            }

            return composite;
          });
        }

        return phase;
      });
    },
    updateMaterial(state, payload) {
      state.phases = state.phases.map(phase => {
        if (phase.id === payload.phaseId) {
          phase.compositesDTO = phase.compositesDTO.map(composite => {
            if (composite.id === payload.compositeId) {
              composite.materials = composite.materials.map(material => {
                if (material.id === payload.material.id) {
                  material = payload.material;
                }

                return material;
              });
            }

            return composite;
          });
        }

        return phase;
      });
    },
  },
  actions: {
    addComposite({ commit }, payload) {
      commit('addComposite', payload);
    },
    addPhases({ commit }, phases) {
      commit('addPhases', phases);
    },
    destroyComposite({ commit }, payload) {
      commit('destroyComposite', payload);
    },
    destroyMaterial({ commit }, payload) {
      commit('destroyMaterial', payload);
    },
    destroyPhase({ commit }, phaseId) {
      commit('destroyPhase', phaseId);
    },
    async init({ commit }, jobId) {
      commit('setLoading');
      commit('setPhases', []);
      const res = await GetPhaseDetails(jobId);
      commit('setPhases', res);
      commit('setLoading', false);
    },
    updateComposite({ commit }, payload) {
      const callback = composite => {
        composite = payload.composite;

        return composite;
      };

      commit('updateComposite', { ...payload, callback: callback });
    },
    updateCompositeName({ commit }, payload) {
      const callback = material => {
        material.jobCompositeName = payload.jobCompositeName;

        return material;
      };

      commit('updateComposite', { ...payload, callback: callback });
    },
    updateMaterial({ commit }, payload) {
      commit('updateMaterial', payload);
    },
  },
};
